import dynamic from "next/dynamic";
import React, { useContext } from "react";
import { FiShoppingCart } from "react-icons/fi";

//internal import
import { SidebarContext } from "@context/SidebarContext";
import { CartContext } from "@context/CartContext";

const StickyCart = () => {
  const { totalItems, cartTotal } = useContext(CartContext);
  const { toggleCartDrawer } = useContext(SidebarContext);

  return (
    <div className="fixed right-0 top-1/2 transform -translate-y-1/2 z-30 hidden lg:block xl:block">
      <button
        aria-label="Cart"
        onClick={toggleCartDrawer}
        className="focus:outline-none"
      >
        <div className="flex flex-col shadow-2xl transition-transform duration-300 hover:translate-x-[-5px] hover:scale-105 rounded-l-xl overflow-hidden">
          <div className="flex flex-col items-center justify-center bg-gray-50 p-3 text-gray-700 border-l border-t border-gray-200">
            <span className="relative text-2xl mb-1 text-red-600 transition-transform duration-300 animate-pulse">
              <FiShoppingCart />
              {totalItems > 0 && (
                <span className="absolute -top-2 -right-2 flex items-center justify-center w-5 h-5 text-xs font-bold bg-gradient-to-r from-red-600 to-red-700 text-white rounded-full shadow-md">
                  {totalItems}
                </span>
              )}
            </span>
            <span className="px-1 text-sm font-serif font-medium">
              {totalItems} {totalItems === 1 ? 'Item' : 'Items'}
            </span>
          </div>
          <div className="flex flex-col items-center justify-center bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 p-3 px-6 text-white text-base font-serif font-medium mx-auto shadow-lg transition-all duration-300 group">
            <span className="group-hover:scale-110 transition-transform duration-300">৳{cartTotal.toFixed(2)}</span>
          </div>
        </div>
      </button>
    </div>
  );
};

export default dynamic(() => Promise.resolve(StickyCart), { ssr: false });
